module.exports = __webpack_public_path__ + "img/CBCBCB_595959_8C8C8C_747474-256px.3c347340.png";